"use strict";

const IncidentInvestigationGeneralInfo = function () {
  const stringKey = "general-info";
  const tabHeader = "General Info";
  let $page;

  var loadListeners = function (data) {
    $page = $(`#assessment-modal #${stringKey}`);

    toggleLocationSection(data.incidentInfo.requestingType);
  };

  var unloadListeners = function () {};

  var getProps = function (data) {
    return {
      precipTypeOptions: IncidentInvestigationConstants.getPrecipitationTypeOptions(),
      investigationTypeOptions: IncidentInvestigationConstants.getInvestigationTypeOptions(),
    };
  };

  var getStringKey = function () {
    return stringKey;
  };

  var getTabHeader = function () {
    return tabHeader;
  };

  var toggleLocationSection = function (requestingType) {
    const show = requestingType === "dry-weather-screen";
    $page.find(`.location-section`).toggle(show);
  };

  return {
    loadListeners,
    unloadListeners,
    getStringKey,
    getTabHeader,
    getProps,
  };
};

module.exports = IncidentInvestigationGeneralInfo();

const IncidentInvestigationConstants = require("./incidentInvestigationConstants");
